import { UPDropdown, UPDropdownItem } from 'components/dropdown';
import { LinkType } from 'constants/LinkType';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  EMPLOYEES__LINK_TYPE,
  EMPLOYEES__LINK_TYPE_APPLICATION,
  EMPLOYEES__LINK_TYPE_ONBOARDING,
  GENERAL__SELECT,
} from 'translations/constants';

interface ILinkTypeSelectorProps {
  value: LinkType;
  /** Matches UPDropdown's change contract, which hands back a select-like event. */
  onChange: (event: { target: { value: string } }) => void;
}

/**
 * Onboarding | Application picker. Rendered only when Job Applicants is enabled for the
 * company — with the flag off the Create tab looks exactly as it did before this story.
 */
const LinkTypeSelector = (props: ILinkTypeSelectorProps): JSX.Element => {
  const { value, onChange } = props;
  const [t] = useTranslation();

  const linkTypeOptions: UPDropdownItem[] = useMemo(
    () => [
      { label: t(EMPLOYEES__LINK_TYPE_ONBOARDING), value: LinkType.Onboarding },
      { label: t(EMPLOYEES__LINK_TYPE_APPLICATION), value: LinkType.Application },
    ],
    [t],
  );

  return (
    <UPDropdown
      value={value}
      onChange={onChange}
      label={t(EMPLOYEES__LINK_TYPE)}
      placeholder={t(GENERAL__SELECT)}
      className="dropdown--white-background"
      items={linkTypeOptions}
      required
    />
  );
};

export default LinkTypeSelector;
